// Menu Content
export const menuItemLeft = [
  {
    id: "01",
    menuLable: "Home",
    navigateTo: "#home",
  },
  {
    id: "03",
    menuLable: "About Us",
    navigateTo: "#aboutus",
  },
  {
    id: "03",
    menuLable: "Services",
    navigateTo: "#services",
  },
];

export const menuItemRight = [
  {
    id: "04",
    menuLable: "Testimonials",
    navigateTo: "#testimonials",
  },
  {
    id: "05",
    menuLable: "FAQ",
    navigateTo: "#faq",
  },
  {
    id: "06",
    menuLable: "Contact Us",
    navigateTo: "#contactus",
  },
];

// About Us Content
export const aboutUs = [
    
    {
        id: '01',
        heading: 'Who We Are',
        shortArticle: "Gayatri Home Tuition is a dedicated home tutoring service committed to helping students excel academically through personalized attention and expert guidance. We are a team of experienced and passionate educators who believe in nurturing young minds with patience, clarity, and care."
    },
    {
        id: '02',
        heading: 'Our Mission',
        shortArticle: "At Gayatri Home Tuition, we believe that every child has the potential to succeed with the right guidance and support. With years of experience in personalized tutoring, we provide quality home-based education tailored to each student’s learning style and academic needs. Whether it's school exams or concept clarity, we are here to make learning easy, effective, and stress-free. Your child’s success is our mission."
    },
    {
        id: '03',
        heading: 'Why Us',
        shortArticle: "At Gayatri Home Tuition, we combine experienced teaching with a personalized approach to ensure your child learns at their own pace and comfort. We focus on concept clarity, regular practice, and result-driven methods. Trusted by parents for consistent academic improvement, we create a supportive learning environment right at your doorstep."
    }
];

// Our Services Content
export const ourServices = [
    {
        id: '01',
        iconName: 'cardIcon01',
        serviceText: 'One-on-one personalized home tutoring for all grades.'
    },
    {
        id: '02',
        iconName: 'cardIcon02',
        serviceText: 'Expert tutors for CBSE, ICSE, and State Boards.'
    },
    {
        id: '03',
        iconName: 'cardIcon03',
        serviceText: 'Free trial class to assess teaching quality.'
    },
    {
        id: '04',
        iconName: 'cardIcon04',
        serviceText: 'Flexible class timings to suit your schedule.'
    },
    {
        id: '05',
        iconName: 'cardIcon05',
        serviceText: 'Regular progress updates and student assessments.'
    },
    {
        id: '06',
        iconName: 'cardIcon06',
        serviceText: 'Special focus on weak subjects and exam preparation.'
    },
    {
        id: '07',
        iconName: 'cardIcon07',
        serviceText: 'Affordable fees with no hidden charges.'
    },
    {
        id: '08',
        iconName: 'cardIcon08',
        serviceText: 'Both in-person and online classes available.'
    },
    {
        id: '09',
        iconName: 'cardIcon09',
        serviceText: 'Trusted by parents for consistent academic growth'
    },
    {
        id: '10',
        iconName: 'cardIcon10',
        serviceText: 'Concept-based teaching with doubt-clearing sessions.'
    },
];

// Testimonials Content
export const testimonials = [
  {
    id: "01",
    profilePicUrl:
      "https://miro.medium.com/v2/resize:fit:4800/format:webp/1*ArQ-WpwydOrxzpXvv-WDkA.jpeg",
    userName: "Anshu",
    feedback:
      "Gayatri Home Tuition helped my son gain confidence in Math. The tutor was extremely patient and clear.",
  },
  {
    id: "02",
    profilePicUrl: "https://randomuser.me/api/portraits/women/65.jpg",
    userName: "Neha Sharma",
    feedback:
      "Very professional and reliable service. My daughter improved her grades significantly within 3 months.",
  },
  {
    id: "03",
    profilePicUrl: "https://randomuser.me/api/portraits/men/32.jpg",
    userName: "Rajeev Khanna",
    feedback:
      "The personal attention given to each student makes a real difference. Highly recommended!",
  },
  {
    id: "04",
    profilePicUrl: "https://randomuser.me/api/portraits/women/12.jpg",
    userName: "Sunita R.",
    feedback:
      "Excellent tutors and flexible timing. Very helpful during exam time.",
  },
  {
    id: "05",
    profilePicUrl: "https://randomuser.me/api/portraits/men/5.jpg",
    userName: "Amit Verma",
    feedback:
      "My son used to hate Science, now he loves it. All thanks to the tutor from Gayatri Home Tuition.",
  },
  {
    id: "06",
    profilePicUrl: "https://randomuser.me/api/portraits/women/76.jpg",
    userName: "Pooja Mehta",
    feedback:
      "Very disciplined and well-organized classes. My daughter enjoys learning now.",
  },
  {
    id: "07",
    profilePicUrl: "https://randomuser.me/api/portraits/men/41.jpg",
    userName: "Rohit Malhotra",
    feedback:
      "Good quality teaching and affordable fees. They also keep you updated on progress regularly.",
  },
  {
    id: "08",
    profilePicUrl: "https://randomuser.me/api/portraits/women/90.jpg",
    userName: "Kavita Singh",
    feedback:
      "Highly qualified teachers who truly care about the student's growth.",
  },
  {
    id: "09",
    profilePicUrl: "https://randomuser.me/api/portraits/men/13.jpg",
    userName: "Dinesh Kumar",
    feedback:
      "The improvement in my daughter’s marks was clearly visible in just two months!",
  },
  {
    id: "10",
    profilePicUrl: "https://randomuser.me/api/portraits/women/24.jpg",
    userName: "Meenakshi Iyer",
    feedback:
      "They explain concepts so well that my son doesn’t need to memorize anymore.",
  },
  {
    id: "11",
    profilePicUrl: "https://randomuser.me/api/portraits/men/33.jpg",
    userName: "Harish M.",
    feedback:
      "Prompt service and excellent teaching methodology. Very happy with the experience.",
  },
  {
    id: "12",
    profilePicUrl: "https://randomuser.me/api/portraits/women/43.jpg",
    userName: "Anita Joshi",
    feedback:
      "My child’s performance in English improved drastically. Highly reliable tutors.",
  },
  {
    id: "13",
    profilePicUrl: "https://randomuser.me/api/portraits/men/66.jpg",
    userName: "Vinay Rao",
    feedback:
      "They keep the sessions interactive and engaging. My son looks forward to every class.",
  },
  {
    id: "14",
    profilePicUrl: "https://randomuser.me/api/portraits/women/35.jpg",
    userName: "Preeti N.",
    feedback:
      "Thank you for making learning stress-free and enjoyable for my daughter!",
  },
  {
    id: "15",
    profilePicUrl: "https://randomuser.me/api/portraits/men/54.jpg",
    userName: "Rakesh Jain",
    feedback:
      "Very punctual and committed tutors. You can rely on them completely.",
  },
  {
    id: "16",
    profilePicUrl: "https://randomuser.me/api/portraits/women/10.jpg",
    userName: "Sneha Kapoor",
    feedback:
      "They customized the learning plan for my child’s needs. Very impressed!",
  },
  {
    id: "17",
    profilePicUrl: "https://randomuser.me/api/portraits/men/79.jpg",
    userName: "Nikhil Arora",
    feedback:
      "Affordable and effective home tuition service. The tutors are polite and well-trained.",
  },
  {
    id: "18",
    profilePicUrl: "https://randomuser.me/api/portraits/women/17.jpg",
    userName: "Manisha Talwar",
    feedback:
      "My son went from average to top of the class in just one term. Thank you, Gayatri Home Tuition!",
  },
  {
    id: "19",
    profilePicUrl: "https://randomuser.me/api/portraits/men/21.jpg",
    userName: "Gaurav Mishra",
    feedback:
      "Supportive tutors who genuinely care about student progress. 10/10 service.",
  },
  {
    id: "20",
    profilePicUrl: "https://randomuser.me/api/portraits/women/55.jpg",
    userName: "Ritu Bansal",
    feedback:
      "Consistent and result-oriented tuition. Best decision I made for my child’s academics.",
  },
];

// FAQ Content
export const faqContent = [
  {
    id: "01",
    question: "What subjects do you offer tuition for?",
    answer:
      "We offer personalized home tuition for all major subjects including Math, Science, English, Social Studies, and optional languages from Grades 1 to 12 (CBSE, ICSE, State Board). Subject availability may vary by grade.",
  },
  {
    id: "02",
    question: "Who are the tutors?",
    answer:
      "Our tutors are qualified and experienced educators, subject matter experts, or trained professionals with a strong academic background and a passion for teaching.",
  },
  {
    id: "03",
    question: "What is the duration and frequency of each class?",
    answer:
      "Typically, each session lasts 1 to 1.5 hours. Frequency is flexible—usually 2 to 5 classes per week depending on the student’s need and availability.",
  },
  {
    id: "04",
    question: "Do you offer one-on-one tuition or group classes?",
    answer:
      "We offer both one-on-one personalized classes and small group sessions (2–4 students) based on the parent's preference and student requirements.",
  },
  {
    id: "05",
    question: "Can I request a trial class?",
    answer:
      "Yes, we offer one free trial class so that you can assess the teaching quality before enrolling.",
  },
  {
    id: "06",
    question: "What is the fee structure?",
    answer:
      "The fee depends on the class level, subject(s), and number of sessions per month. Please contact us directly for a customized fee quote.",
  },
  {
    id: "07",
    question: "Is there any registration fee or hidden charges?",
    answer:
      "No, we do not charge any registration fees or have hidden costs. You pay only for the tuition sessions you choose.",
  },
  {
    id: "08",
    question: "How do you ensure the quality of teaching?",
    answer:
      "We regularly monitor tutor performance, gather feedback from parents/students, and conduct academic assessments to ensure consistent learning outcomes.",
  },
  {
    id: "09",
    question: "What if I want to change the tutor later?",
    answer:
      "You can request a tutor change anytime if you're not satisfied. We’ll do our best to assign another suitable tutor quickly.",
  },
  {
    id: "10",
    question: "Do you provide online classes as well?",
    answer:
      "Yes, we offer both in-person and online classes to cater to your convenience and preferences.",
  }
];